import { useMutation } from '@tanstack/react-query';

import { useAppDispatch } from 'store';

import { $apiV2, errorHandler } from 'modules/global';

import { setAnswerResult } from '../store';

export const useCheckAutoTest = () => {
  const dispatch = useAppDispatch();

  return useMutation({
    mutationFn: async ({ testId, optionId }: { testId?: number; optionId?: number }) => {
      const { data } = await $apiV2.post('/check-test/check', {
        id: testId,
        option_id: optionId
      });

      return data;
    },
    onSuccess: (data, { testId, optionId }) => {
      dispatch(
        setAnswerResult({
          questionId: testId as number,
          isRight: data.data.is_right,
          rightAnswer: data.data.is_true,
          selectedAnswer: optionId
        })
      );
    },
    onError: errorHandler()
  });
};
